export const ERROR_LEVEL = 0;
export const WARN_LEVEL = 1;
export const LOG_LEVEL = 2;
export const INFO_LEVEL = 3;
export const DEBUG_LEVEL = 4;
export const TRACE_LEVEL = 5;
